/* eslint-disable react/jsx-curly-newline */
/* eslint-disable indent */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable eqeqeq */
/* eslint-disable react/self-closing-comp */
/* eslint-disable comma-dangle */
/* eslint-disable no-plusplus */
/* eslint-disable class-methods-use-this */
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FallingLines } from 'react-loader-spinner';
import { submitOrder, getSystemSettings } from '../../Utils/RestUtils';
import BuyerForm from '../BuyerForm/BuyerForm';
import TouristForm from '../TouristForm/TouristForm';
import { ReactComponent as DefaultCheck } from '../../images/default-check-r.svg';
import { ReactComponent as ActiveCheck } from '../../images/active-check-r.svg';
// import Timer from '../Timer/Timer';
import {
  EMAIL,
  PHONE,
  CONTACT_INFO,
  BUYER_INFO,
  FILL_DATA,
  PAYMENT_IS_NOT_AVAIL,
  NOTE,
  TOURISTS_DATA,
  FLIGHT,
  TOUR_DATA_CHECK,
  ORDER_NOT_FOUND,
  HOTEL,
} from '../../Utils/Constants/CheckoutConstants';
import {
  getDayText,
  getNightsText,
  getTouristsTextActualiz,
  firstLetterInUpperCase,
} from '../../Utils/CommonUtils';
import { changeTimeIsUpVisibility } from '../../DataStore/actions/searchFormActions';
import { CHECKOUT_TITLE } from '../../Utils/Constants/SEO';
import './css/Checkout.css';
import PriceText from '../PriceText/PriceText';
import {
  ROOM_TYPE,
  MEAL,
  PLACEMENT,
  PAY_NOW,
  TOUR_DETAILS,
  OPERATOR,
  PROGRAMM,
  TOUR_INCLUDED,
  TOUR_INC_AVIA,
  TOUR_INC_HOTEL,
  TOUR_INC_MED,
  TOUR_INC_TRANSFER,
  TOUR_PAYMENT,
  TOTAL,
  FLIGHT_INSURANCE,
} from '../../Utils/Constants/GlobalConstants';
import { meals } from '../../Utils/Constants/Meals';
import { ReactComponent as GrayCalendar } from '../../images/gray-calendar-r.svg';
import { ReactComponent as GrayPerson } from '../../images/gray-person-r.svg';
import NoResults from '../../images/no-results.png';
import {
  getEmptyContractInfo,
  getEmptyTourists,
  isContractInfoValid,
  isTouristsValid,
  getContactInfoPayload,
  getTouristsPayload,
  getTouristTitle,
} from '../../Utils/OrderUtil';

const mapStateToProps = (state) => ({ ...state });

class Checkout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sellOnStop: false,
      paymentTest: false,
      // isContentDisabled: false,
      // currentTime: '',
      // timerReset: null,
      contractInfo: getEmptyContractInfo(),
      tourists: [],
      offertaAccepted: false,
      isSubmitSpinnerVisible: false,

      isPageValid: false,
      acualizationData: {},
      order: {},
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    getSystemSettings()
      .then((result) => {
        if (result && result.data && result.data.length > 0) {
          const { sellOnStop, paymentTest } = result.data[0];
          if (sellOnStop === true) {
            this.setState({ sellOnStop: true });
          }

          if (paymentTest === true) {
            this.setState({ paymentTest: true });
          }
        }
      })
      .catch();

    const { location } = this.props;
    if (location.state) {
      const { acualizationData, order } = location.state;

      if (acualizationData && order) {
        this.setState({
          acualizationData,
          order,
          tourists: getEmptyTourists(order),
          isPageValid: true,
        });
      }
    }
  }

  renderTuristsDataForm = () => {
    const { tourists, order } = this.state;

    return tourists.map((tourist, index) => (
      <TouristForm
        key={`tourist-data-${tourist.id}`}
        title={getTouristTitle(order, index)}
        tourist={tourist}
        handleChange={this.handleTouristChange}
        handleValid={this.handleTouristValid}
        handleSexChange={this.handleTouristSexSelector}
      />
    ));
  };

  handleContractChange = (name, value) => {
    const { contractInfo } = this.state;
    const validFieldName = `${name}Valid`;
    this.setState({
      contractInfo: { ...contractInfo, [name]: value, [validFieldName]: true },
    });
  };

  handleContractValid = (name, value) => {
    const { contractInfo } = this.state;
    const fieldName = `${name}Valid`;
    this.setState({ contractInfo: { ...contractInfo, [fieldName]: value } });
  };

  handleContrakctSexSelector = (value) => {
    const { contractInfo } = this.state;
    this.setState({
      contractInfo: { ...contractInfo, sex: value, sexValid: true },
    });
  };

  handleTouristSexSelector = (value, id) => {
    const { tourists } = this.state;

    const newState = tourists.map((tourist) => {
      // eslint-disable-next-line eqeqeq
      if (tourist.id == id) {
        return { ...tourist, sex: value, sexValid: true };
      }

      return tourist;
    });

    this.setState({ tourists: newState });
    // this.setState({ contractInfo: { ...contractInfo, sex: value } });
  };

  handleTouristChange = (name, value, id) => {
    const { tourists } = this.state;
    const validFieldName = `${name}Valid`;

    const newState = tourists.map((tourist) => {
      // eslint-disable-next-line eqeqeq
      if (tourist.id == id) {
        return { ...tourist, [name]: value, [validFieldName]: true };
      }

      return tourist;
    });

    this.setState({ tourists: newState });
  };

  handleTouristValid = (name, value, id) => {
    const { tourists } = this.state;

    const fieldName = `${name}Valid`;

    const newState = tourists.map((tourist) => {
      // eslint-disable-next-line eqeqeq
      if (tourist.id == id) {
        return { ...tourist, [fieldName]: value };
      }

      return tourist;
    });

    this.setState({ tourists: newState });
  };

  isPayDisabled = () => {
    const { sellOnStop, offertaAccepted, contractInfo, tourists } = this.state;

    return !(
      isContractInfoValid(contractInfo) &&
      isTouristsValid(tourists) &&
      !sellOnStop &&
      offertaAccepted
    );
  };

  // timeIsUp = (callBack) => {
  //   const { changeTimeIsUpVisibility: changeTimeIsUpVisibilityAction } =
  //     this.props;
  //   changeTimeIsUpVisibilityAction(true);

  //   this.topRef.scrollIntoView({ behavior: 'smooth' });

  //   this.setState({ timerReset: callBack });
  // };

  // onModalButtonClick = () => {
  //   const {
  //     changeTimeIsUpVisibility: changeTimeIsUpVisibilityAction,
  //     location,
  //   } = this.props;
  //   const { tourPricePayload } = location.state;
  //   const { timerReset } = this.state;

  //   changeTimeIsUpVisibilityAction(false);
  //   this.setState({ isContentDisabled: true });

  //   getTourPrice(tourPricePayload)
  //     .then((result) => {
  //       this.setState({
  //         priceData: result.data,
  //       });
  //     })
  //     .finally(() => {
  //       this.setState({ isContentDisabled: false });
  //       timerReset();
  //     });
  // };

  // currentTimeUpdate = (time) => {
  //   this.setState({ currentTime: time });
  // };

  handleOfferta = () => {
    const { offertaAccepted } = this.state;
    this.setState({ offertaAccepted: !offertaAccepted });
  };

  handleSubmitOrder = (btnRef) => {
    btnRef.current.setAttribute('disabled', 'disabled');
    this.setState({ isSubmitSpinnerVisible: true });

    const { location } = this.props;
    const { contractInfo, tourists } = this.state;

    const { order } = location.state;

    const payload = { ...order };

    payload.contactInfo = getContactInfoPayload(contractInfo);
    payload.tourists = getTouristsPayload(tourists);

    submitOrder(payload).then((response) => {
      if (response && response.data) {
        window.location.replace(response.data.formUrl);
      }
    });
  };

  getMeal = (acualizationData) => {
    let result = '';

    if (acualizationData.mealcode) {
      const filteredMeal = meals.filter(
        (e) => e.id === acualizationData.mealcode,
      );

      if (filteredMeal.length > 0) {
        result = filteredMeal[0].russianfull;
      } else {
        result = acualizationData.meal;
      }
    } else {
      result = acualizationData.meal;
    }

    return result;
  };

  getPayButtonValue = (order) => {
    if (order.split !== 100) {
      return order.splitPayment;
    }

    return order.totalPrice;
  };

  isRegular = (data) => data.regular && data.regular == 1;

  getFlightData = (flihgtArray) => {
    const result = [];

    for (let i = 0; i < flihgtArray.length; i++) {
      result.push(<div className="br_text_16">{flihgtArray[i]}</div>);
    }

    return result;
  };

  isFlightVisible = (order) =>
    order.toTrip &&
    order.backTrip &&
    order.toTrip.length > 0 &&
    order.backTrip.length > 0;

  render() {
    const { acualizationData, order } = this.state;

    const {
      contractInfo,
      isSubmitSpinnerVisible,
      sellOnStop,
      paymentTest,
      offertaAccepted,
      isPageValid,
    } = this.state;

    const isDisabled = this.isPayDisabled();
    const btnRef = createRef();

    return (
      <div>
        <Helmet>
          <title>{CHECKOUT_TITLE}</title>
        </Helmet>
        <div className="containerW">
          <div className="container">
            {isPageValid ? (
              <div>
                <div className="ch_title">{TOURISTS_DATA}</div>
                <div className="ch_container">
                  <div className="ch_section_left">
                    <div className="ch_section_w">
                      <div className="bb_text_20 mb_20">{BUYER_INFO}</div>
                      <BuyerForm
                        contractInfo={contractInfo}
                        handleChange={this.handleContractChange}
                        handleValid={this.handleContractValid}
                        handleSexChange={this.handleContrakctSexSelector}
                      />
                    </div>
                    {this.renderTuristsDataForm()}
                  </div>
                  <div className="bm_text_38 ch_tablet_tour_check_title">
                    {TOUR_DATA_CHECK}
                  </div>
                  <div className="ch_section_right">
                    <div className="ch_tour_details_sections">
                      <div className="ch_tour_details_section">
                        <div className="ch_tour_details_dot"></div>
                        <div className="bb_text_20 ch_section_title">
                          {TOUR_DETAILS}
                        </div>
                        <div className="ch_tour_det_w">
                          <div className="mb_20">
                            <div className="od_tour_det_item">
                              <GrayCalendar className="od_tour_det_icon" />
                              <div className="br_text_16">{`${getDayText(
                                acualizationData.flydate,
                              )} / ${getNightsText(
                                acualizationData.nights,
                              )}`}</div>
                            </div>
                            <div className="od_tour_det_item">
                              <GrayPerson className="od_tour_det_icon" />
                              <div className="br_text_16">
                                {getTouristsTextActualiz(acualizationData)}
                              </div>
                            </div>
                          </div>

                          <div className="mb_20">
                            <div className="bb_text_16 mb_4">{OPERATOR}</div>
                            <div className="br_text_16">
                              {acualizationData.operatorname &&
                                acualizationData.operatorname}
                            </div>
                          </div>

                          {acualizationData.hotelname && (
                            <div className="mb_20">
                              <div className="bb_text_16 mb_4">{HOTEL}</div>
                              <div className="br_text_16">
                                {firstLetterInUpperCase(
                                  acualizationData.hotelname,
                                )}
                              </div>
                            </div>
                          )}

                          {acualizationData.tourname && (
                            <div className="mb_20">
                              <div className="bb_text_16 mb_4">{PROGRAMM}</div>
                              <div className="br_text_16">
                                {acualizationData.tourname}
                              </div>
                            </div>
                          )}

                          {acualizationData.room && (
                            <div className="mb_20">
                              <div className="bb_text_16 mb_4">{ROOM_TYPE}</div>
                              <div className="br_text_16">
                                {acualizationData.room}
                              </div>
                            </div>
                          )}

                          {acualizationData.placement && (
                            <div className="mb_20">
                              <div className="bb_text_16 mb_4">{PLACEMENT}</div>
                              <div className="br_text_16">
                                {acualizationData.placement}
                              </div>
                            </div>
                          )}

                          <div className="mb_20">
                            <div className="bb_text_16 mb_4">{MEAL}</div>
                            <div className="br_text_16">
                              {this.getMeal(acualizationData)}
                            </div>
                          </div>

                          {order.note && (
                            <div className="mb_20">
                              <div className="bb_text_16 mb_4">{NOTE}</div>
                              <div className="br_text_16">{order.note}</div>
                            </div>
                          )}

                          {!this.isRegular(acualizationData) && (
                            <div className="mb_20">
                              <div className="bb_text_16 mb_4">
                                {TOUR_INCLUDED}
                              </div>
                              <div className="br_text_16">
                                <div className="mb_2">{TOUR_INC_AVIA}</div>
                                <div className="mb_2">{TOUR_INC_HOTEL}</div>
                                <div className="mb_2">{TOUR_INC_MED}</div>
                                <div>{TOUR_INC_TRANSFER}</div>
                              </div>
                            </div>
                          )}

                          {order.flightInsurance === true && (
                            <div className="mb_20">
                              <div className="bb_text_16">
                                {FLIGHT_INSURANCE}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {this.isFlightVisible(order) && (
                        <div className="ch_tour_details_section">
                          <div className="ch_tour_details_dot"></div>
                          <div className="bb_text_20 ch_section_title">
                            {FLIGHT}
                          </div>

                          <div className="ch_tour_det_w">
                            <div className="mb_10">
                              <div>{this.getFlightData(order.toTrip)}</div>
                            </div>
                            <div className="mb_10">
                              <div>{this.getFlightData(order.backTrip)}</div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="ch_tour_details_section">
                        <div className="ch_tour_details_dot"></div>
                        <div className="bb_text_20 ch_section_title">
                          {CONTACT_INFO}
                        </div>

                        <div className="ch_tour_det_w">
                          <div className="mb_14">
                            <div className="gr_text_14 mb_6">{EMAIL}</div>
                            <div className="bm_text_16">{order.email}</div>
                          </div>
                          <div>
                            <div className="gr_text_14 mb_6">{PHONE}</div>
                            <div className="bm_text_16">
                              {order.phoneNumber}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ch_tour_details_section">
                        <div className="ch_tour_details_dot_last"></div>
                        <div className="bb_text_20 ch_section_title">
                          {TOUR_PAYMENT}
                        </div>

                        <div className="ch_tour_det_w">
                          <div className="ch_pay_w">
                            <div className="ch_payment_line mb_4">
                              <div className="br_text_26">{TOTAL}</div>
                              <div className="bm_text_26">
                                <PriceText text={order.totalPrice} />
                              </div>
                            </div>

                            {order.split !== 100 && (
                              <div>
                                <div className="ch_payment_line">
                                  <div className="br_text_16">{PAY_NOW}</div>
                                  <div className="bm_text_16">
                                    <PriceText text={order.splitPayment} />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <button
                            type="button"
                            className="mb_20"
                            onClick={this.handleOfferta}
                          >
                            <div className="ch_oferta_line">
                              {offertaAccepted ? (
                                <ActiveCheck className="ch_oferta_check" />
                              ) : (
                                <DefaultCheck className="ch_oferta_check" />
                              )}
                              <div className="ch_oferta_link">
                                <span className="br_text_14">Я согласен с</span>
                                &nbsp;
                                <Link
                                  to="/file/oferta.pdf"
                                  target="_blank"
                                  className="ch_link_oferta blue_link"
                                >
                                  договором публичной оферты
                                </Link>
                              </div>
                            </div>
                          </button>

                          <button
                            ref={btnRef}
                            type="button"
                            className={`wm_text_16 ch_ckeckout_btn  ${
                              isDisabled ? 'btn_dis' : 'blue_button'
                            }`}
                            disabled={isDisabled}
                            onClick={() => this.handleSubmitOrder(btnRef)}
                          >
                            <div className="ch_pay_spinner_w">
                              <div>
                                <PriceText
                                  text={`Оплатить ${this.getPayButtonValue(
                                    order,
                                  )}`}
                                />
                              </div>
                              <div className="ch_submit_spinner_w">
                                <FallingLines
                                  color="#ffffff"
                                  width="30"
                                  visible={isSubmitSpinnerVisible}
                                  ariaLabel="falling-circles-loading"
                                />
                              </div>
                            </div>
                          </button>
                          {isDisabled && (
                            <div className="gr_text_14">
                              {FILL_DATA}
                              &nbsp;
                              <span className="input_required">*</span>
                            </div>
                          )}
                          {sellOnStop && (
                            <div className="gr_text_14">
                              {PAYMENT_IS_NOT_AVAIL}
                            </div>
                          )}
                          {paymentTest && (
                            <div className="gr_text_14">Тестовый платеж</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="ch_no_re_w">
                <div className="ch_no_res">
                  <img src={NoResults} alt="" className="mb_5" />
                  <div className="br_text_18">{ORDER_NOT_FOUND}</div>
                </div>
              </div>
            )}
          </div>

          {/* Timer */}
          {/* <div className="ch_section_w">
            <div className="ch_timer_w">
              {PRICE_ACTUALIZATION}
              &nbsp;
              <Timer
                time={20}
                timeIsUp={this.timeIsUp}
                currentTime={currentTime}
                currentTimeUpdate={this.currentTimeUpdate}
              />
            </div>
          </div> */}

          {/* <div
            className={`ch_spinner_wrapper ${
              isContentDisabled ? '' : 'ch_invisible'
            }`}
          >
            <div>
              <Bars
                height="40"
                width="40"
                color="#00BFFF"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={isContentDisabled}
              />
            </div>
          </div> */}

          {/* Modal */}
          {/* <div
            className={`ch_outdated_modal_w ${
              timeIsUpModalVisible ? '' : 'ch_invisible'
            }`}
          >
            <div className="ch_outdated_modal">
              <div className="ch_modal_text">Данные тура могли устареть</div>
              <div>
                <button
                  type="button"
                  className="btn btn__yellow ch_modal_button"
                  onClick={() => this.onModalButtonClick()}
                >
                  Проверить
                </button>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

Checkout.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
};

export default connect(mapStateToProps, {
  changeTimeIsUpVisibility,
})(Checkout);
